<template>
  <main class="hero">
    <div class="hero-title">
      <h1>
        Trouvez votre<br>
        futur compagnon de vie<br>
        <span class="accent">près de chez vous</span>
      </h1>
    </div>

    <div class="dots" aria-hidden="true">
      <span></span><span class="active"></span><span></span><span></span>
    </div>

    <div class="hero-content">
      <section class="layout">
        <!-- LEFT -->
        <div class="side left-start" aria-hidden="true">
          <div class="col left">
            <div class="tile" :style="tileStyle(0)"></div>
            <div class="tile" :style="tileStyle(1)"></div>
          </div>

          <div class="col middle">
            <div class="tile" :style="tileStyle(2)"></div>
            <div class="tile" :style="tileStyle(3)"></div>
          </div>

          <div class="col right">
            <div class="tile" :style="tileStyle(4)"></div>
            <div class="tile" :style="tileStyle(5)"></div>
          </div>
        </div>

        <!-- RIGHT -->
        <div class="side right-start" aria-hidden="true">
          <div class="col left">
            <div class="tile" :style="tileStyle(6)"></div>
            <div class="tile" :style="tileStyle(7)"></div>
          </div>

          <div class="col middle">
            <div class="tile" :style="tileStyle(8)"></div>
            <div class="tile" :style="tileStyle(9)"></div>
          </div>

          <div class="col right">
            <div class="tile" :style="tileStyle(10)"></div>
            <div class="tile" :style="tileStyle(11)"></div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref } from "vue";

const API_URL = "https://admin.asso-refuge.fr/getAllAnimal";
const IMG_BASE_URL = "https://admin.asso-refuge.fr/images/";

const animals = ref([]);
const currentPage = ref(0);
const intervalId = ref(null);

const IMAGES_PER_PAGE = 12;
const AUTOPLAY_DELAY = 4000; // ms (4,5s)







/* =========================
   FETCH
========================= */
onMounted(async () => {
  try {
    const res = await fetch(API_URL);
    const data = await res.json();
    animals.value = Array.isArray(data) ? data : (data?.data ?? []);
    startAutoplay();
  } catch (e) {
    console.error("Erreur chargement animaux", e);
  }
});

onUnmounted(() => {
  stopAutoplay();
});

/* =========================
   IMAGES
========================= */
const allImages = computed(() =>
  animals.value
    .map(a => a.img1 || a.img2 || a.img3)
    .filter(Boolean)
    .map(img => `${IMG_BASE_URL}${img}`)
);

const totalPages = computed(() =>
  Math.ceil(allImages.value.length / IMAGES_PER_PAGE)
);

const visibleImages = computed(() => {
  const start = currentPage.value * IMAGES_PER_PAGE;
  const slice = allImages.value.slice(start, start + IMAGES_PER_PAGE);

  // sécurité : toujours 12 images
  if (slice.length < IMAGES_PER_PAGE && allImages.value.length) {
    let i = 0;
    while (slice.length < IMAGES_PER_PAGE) {
      slice.push(allImages.value[i % allImages.value.length]);
      i++;
    }
  }

  return slice;
});

/* =========================
   CAROUSEL
========================= */
function nextPage() {
  currentPage.value =
    currentPage.value + 1 >= totalPages.value ? 0 : currentPage.value + 1;
}

function startAutoplay() {
  stopAutoplay();
  intervalId.value = setInterval(nextPage, AUTOPLAY_DELAY);
}

function stopAutoplay() {
  if (intervalId.value) {
    clearInterval(intervalId.value);
    intervalId.value = null;
  }
}

/* =========================
   TILE STYLE
========================= */
function tileStyle(index) {
  const url = visibleImages.value[index];

  if (!url) {
    return { background: "#e5e7eb" };
  }

  return {
    backgroundImage: `url("${url}")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };
}
</script>


<style src="../assets/css/home.css" scoped></style>
